import { render, staticRenderFns } from "./WinnerInfo.vue?vue&type=template&id=e2143dfe&"
import script from "./WinnerInfo.vue?vue&type=script&lang=js&"
export * from "./WinnerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports